<template>
  <div class="enterprise-declaration-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <el-tabs type="border-card">
        <el-tab-pane label="园区信息">
          <div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">园区剩余可租面积：</span>
              </div>
              <el-input v-model="formData.rentArea" size="small" style="width: 280px" >
                <template slot="append">平方米</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">园区剩余可售面积：</span>
              </div>
              <el-input v-model="formData.saleArea" size="small" style="width: 280px" >
                <template slot="append">平方米</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">已出售面积：</span>
              </div>
              <el-input v-model="formData.soldArea" size="small" style="width: 280px" >
                <template slot="append">平方米</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">已出租面积：</span>
              </div>
              <el-input v-model="formData.rentedArea" size="small" style="width: 280px" >
                <template slot="append">平方米</template>
              </el-input>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="企业信息">
          <div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">入驻企业总数：</span>
              </div>
              <el-input v-model="formData.companyNumber" size="small" style="width: 280px" >
                <template slot="append">家</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">入驻企业员工总数：</span>
              </div>
              <el-input v-model="formData.allEmployeeNumber" size="small" style="width: 280px" >
                <template slot="append">人</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">入驻企业营业总收入：</span>
              </div>
              <el-input v-model="formData.allRevenueTotal" size="small" style="width: 280px" >
                <template slot="append">万元</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">本年度累计安全生产事故数：</span>
              </div>
              <el-input v-model="formData.allSafetyEvent" size="small" style="width: 280px" >
                <template slot="append">件</template>
              </el-input>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="能耗计量">
          <div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">用电量本期值：</span>
              </div>
              <el-input v-model="formData.electricityData" size="small" style="width: 280px" >
                <template slot="append">千瓦时</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中第1个月用电量本期值：</span>
              </div>
              <el-input v-model="formData.currentElectricityFirstMonth" size="small" style="width: 280px" >
                <template slot="append">千瓦时</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中第2个月用电量本期值：</span>
              </div>
              <el-input v-model="formData.currentElectricitySecondMonth" size="small" style="width: 280px" >
                <template slot="append">千瓦时</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中第3个月用电量本期值：</span>
              </div>
              <el-input v-model="formData.currentElectricityThirdMonth" size="small" style="width: 280px" >
                <template slot="append">千瓦时</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">用水量本期值：</span>
              </div>
              <el-input v-model="formData.waterData" size="small" style="width: 280px" >
                <template slot="append">吨</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中第1个月用水量本期值：</span>
              </div>
              <el-input v-model="formData.currentWaterFirstMonth" size="small" style="width: 280px" >
                <template slot="append">吨</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中第2个月用水量本期值：</span>
              </div>
              <el-input v-model="formData.currentWaterSecondMonth" size="small" style="width: 280px" >
                <template slot="append">吨</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中第3个月用水量本期值：</span>
              </div>
              <el-input v-model="formData.currentWaterThirdMonth" size="small" style="width: 280px" >
                <template slot="append">吨</template>
              </el-input>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="党群信息">
          <div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中党员人数：</span>
              </div>
              <el-input v-model="formData.partyNumber" size="small" style="width: 280px" >
                <template slot="append">人</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">是否有党组织：</span>
              </div>
              <el-select v-model="formData.partyBranch" placeholder="请选择" size="mini" style="width: 280px">
                <el-option
                  v-for="item in partyBranchList"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" value="保存" v-if="formData.approveNode === '0' && formData.approveStatus !== '1'"/>
        <button-cancel @cancel="addApproveChain" value="保存并审批" v-if="formData.approveNode === '0' && formData.approveStatus !== '1'"/>
        <button-cancel @cancel="cancel" value="返回" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {getObjectURL} from '../../../utils/toBase64'
import $ from 'jquery'
import {api} from '../../api/PoliticalCommunication'
import {nError, nSuccess} from '../../../utils/notice'
import {errorHandler} from '../../../utils/errorHandler'
import bus from "../../../utils/bus";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'quarterly-data-report-modify',
  data () {
    return {
      breadcrumb: [{
        value: '小微政通',
        name: 'quarterly-data-report-manage'
      }, {
        value: '季度数据上报'
      }],
      mainTitle: '季度数据上报',
      subheading: '',

      partyBranchList: [
        {key: '0', label: '否'},
        {key: '1', label: '是'},
      ],

      formData: {
        rentArea: '', // 园区剩余可租面积
        saleArea: '', // 园区剩余可售面积
        soldArea: '', // 已出售面积
        rentedArea: '', // 已出租面积

        companyNumber: '', // 入驻企业总数
        allEmployeeNumber: '', // 入驻企业员工总数
        allRevenueTotal: '', // 入驻企业营业总收入
        allSafetyEvent: '', // 本年度累计安全生产事故数

        electricityData: '', // 用电量本期值
        currentElectricityFirstMonth: '', // 其中第 1 个月用电量本期值
        currentElectricitySecondMonth: '', // 其中第 2 个月用电量本期值
        currentElectricityThirdMonth: '', // 其中第 3 个月用电量本期值
        waterData: '', // 用水量本期值
        currentWaterFirstMonth: '', // 其中第1个月用水量本期值
        currentWaterSecondMonth: '', // 其中第2个月用水量本期值
        currentWaterThirdMonth: '', // 其中第3个月用水量本期值

        partyNumber: '', // 其中党员人数
        partyBranch: '', // 是否有党组织
      },
    }
  },
  created() {
    this.getQuarterlyDataByCode()
  },
  mounted () {},
  methods: {
    // 查询信息
    getQuarterlyDataByCode () {
      this.$axios.get(`${api.getQuarterlyDataByCode}/${this.$route.params.id}`, {})
        .then(res => {
          let data = res.data.data
          this.formData = data
        })
        .catch(errorHandler('查询失败'))
    },
    toManagePage () {
      this.$router.push({
        name: 'quarterly-data-report-manage'
      })
    },

    confirm () {
      this.$axios.post(api.updateQuarterlyData, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('保存成功')
            this.toManagePage()
          }
        })
        .catch(errorHandler('保存失败'))
    },
    // 提交审批
    addApproveChain () {
      this.$axios.post(api.updateQuarterlyData, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            this.$axios.post(`${api.addApproveChain}`, {
              uploadDataCode: this.formData.code,
              uploadDataType: '1',
              approveName: this.formData.teskName,
              sponsorAccountCode: bus.global.accountCode,
              sponsorAccountName: bus.global.accountName,
            })
              .then(res => {
                if (res.data.retCode === 1) {
                  nSuccess('操作成功')
                  this.toManagePage()
                }
              })
              .catch(errorHandler('操作失败'))
          }
        })
        .catch(errorHandler('保存失败'))
    },
    cancel () {
      this.toManagePage()
    }
  }
}
</script>

<style scoped>
form {
  width: 100%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
}
.form-title {
  color: #333333;
  font-size: 16px;
  line-height: 24px;
  padding-left: 5px;
  margin-top: 5px;
  border-left: 3px solid #00a0e6;
}
.form-line {
  margin: 10px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.line-text{
  color: #48576a;
  font-size: 14px;
}
.textBox {
  display: inline-block;
  width: 240px;
  min-width: 145px;
  line-height: 32px;
  text-align: right;
}

.form-btn-box {
  margin: 30px auto;
  display: flex;
  justify-content: flex-end;
}
</style>

<style lang="less">
.enterprise-declaration-add {
  .form-line-table-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .form-line-table-top-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 12px;
    }
  }
}
.el-switch {
  height: 30px;
}

</style>




// WEBPACK FOOTER //
// src/view/PoliticalCommunication/QuarterlyDataReport/QuarterlyDataReportModify.vue